module.exports = __webpack_public_path__ + "img/wrong.35840c69.png";